'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"
import router from "@/router";

export default {
    async getAnalytics(year, storeId) {
        const data = {
            method: 'get',
            url: 'analytics/' + year + '/' + storeId,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        } else if(response.status === 401){
            sessionStorage.clear();
            router.push('/login')
        }
    },
    async getStoreAnalytics(storeId, duration) {
        const data = {
            method: 'get',
            url: 'storeStats/' + storeId + '/' + duration,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async searchStoreAnalytics(json) {
        const data = {
            method: 'post',
            url: 'searchStoreStats',
            body: json
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async getProductPopularity(count) {
        const data = {
            method: 'get',
            url: 'productsPopularity/' + count
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async getProductProfitability(count) {
        const data = {
            method: 'get',
            url: 'productsProfitability/' + count
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async getYears() {
        const data = {
            method: 'get',
            url: 'years',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async getStockTakeAnalytics(year = null, params = {}) {
        const url = year ? `stockTakeAnalytics/${year}` : 'stockTakeAnalytics';
        const data = {
            method: 'post',
            url: url,
            body: params
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        } else if(response.status === 401){
            sessionStorage.clear();
            router.push('/login')
        }
    },
    async getProductSalesWithStock(params = {}) {
        const data = {
            method: 'post',
            url: 'productSalesWithStock',
            body: params
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        } else if(response.status === 401){
            sessionStorage.clear();
            router.push('/login')
        }
    },
    async getMonthlyProductSalesWithStock(params = {}) {
        const data = {
            method: 'post',
            url: 'monthlyProductSalesWithStock',
            body: params
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        } else if(response.status === 401){
            sessionStorage.clear();
            router.push('/login')
        }
    },
    async getTopSellingCategories(params = {}) {
        const data = {
            method: 'post',
            url: 'topSellingCategories',
            body: params
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        } else if(response.status === 401){
            sessionStorage.clear();
            router.push('/login')
        }
    },
    async getLowStockProducts(params = {}) {
        const data = {
            method: 'post',
            url: 'lowStockProducts',
            body: params
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        } else if(response.status === 401){
            sessionStorage.clear();
            router.push('/login')
        }
    },
    async getSalesTrends(params = {}) {
        const data = {
            method: 'post',
            url: 'salesTrends',
            body: params
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        } else if(response.status === 401){
            sessionStorage.clear();
            router.push('/login')
        }
    },
    async getRevenueByPaymentMethod(params = {}) {
        const data = {
            method: 'post',
            url: 'revenueByPaymentMethod',
            body: params
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        } else if(response.status === 401){
            sessionStorage.clear();
            router.push('/login')
        }
    },
    async getProductPerformance(params = {}) {
        const data = {
            method: 'post',
            url: 'productPerformance',
            body: params
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        } else if(response.status === 401){
            sessionStorage.clear();
            router.push('/login')
        }
    }
}
